'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = require('react-intl');

var genderLabels = (0, _reactIntl.defineMessages)({
    1: {
        'id': 'formOptions.genderLabels.1',
        'defaultMessage': 'Male'
    },
    2: {
        'id': 'formOptions.genderLabels.2',
        'defaultMessage': 'Female'
    }
});

exports.default = genderLabels;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/metadata/forms/formOptions/gender/genderLabels.js
// module id = 1370
// module chunks = 0